export default __webpack_public_path__ + "static/media/plantilla_2_powerpoint.01316ec9.jpg";